import React from 'react'
import RSelect from 'react-select'

const contains = (value, list) => list.find(x => x === value) !== undefined
const SimpleSelect = (props) => {

  const { onChange, value, valueField, textField, nullable, localize, loading, data, getLabel, isEnum, isMulti, disabled, ...otherProps } = props
  const handleOnChange = (item) => {
    if (typeof onChange === 'function') {
      if (isMulti) {
        const values = (item && item.length > 0 ? item.map(x => x[valueField]) : item)
        onChange(item, values)
      } else {
        const value = (item ? item[valueField] : item)
        onChange(item, value)
      }
    }
  }
  let selectedItem = undefined
  if (!loading) {
    if (isMulti) {
      if (value !== null && value !== undefined && value.length > 0) {
        const values = isEnum ? value : value.map(x => x[valueField])
        const items = (data || []).filter(x => contains(x[valueField], values))
        selectedItem = items.length > 0 ? items : value
      } else {
        selectedItem = null
      }
    } else {
      if (value !== null && value !== undefined) {
        selectedItem = data.find(x => x[valueField] === (isEnum ? value : value[valueField])) || value
      }
      else
      {
        selectedItem = null
      }
    }
  }
  const getOptionLabel = (item) => item[textField]
  const getOptionValue = (item) => item[valueField]

  return (<div className='select-wrapper'><RSelect
    {...otherProps}
    isDisabled={disabled}
    isMulti={isMulti}
    options={data}
    getOptionLabel={getLabel || getOptionLabel}
    getOptionValue={getOptionValue}
    value={selectedItem}
    isLoading={loading}
    isClearable={nullable}
    
    placeholder={localize('common.selectValue')}
    onChange={handleOnChange}
    /></div>)
}

export {
  SimpleSelect
}